<script lang="ts" context="module">
  /** One breadcrumb segment. `href` omitted ⇒ rendered as the current (active) leaf. */
  export interface Crumb {
    label: string;
    href?: string;
  }
</script>

<script lang="ts">
  import { link } from "svelte-spa-router";

  export let items: Crumb[] = [];
</script>

<nav class="crumbs" aria-label="Breadcrumb" data-testid="breadcrumb">
  {#each items as c, i (i)}
    {#if c.href && i < items.length - 1}
      <a href={c.href} use:link data-testid="crumb-{i}">{c.label}</a>
    {:else}
      <span class="current" aria-current="page" data-testid="crumb-{i}">{c.label}</span>
    {/if}
    {#if i < items.length - 1}
      <span class="sep" aria-hidden="true">/</span>
    {/if}
  {/each}
</nav>

<style>
  .crumbs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
    font-size: 0.85rem;
    margin-bottom: 0.85rem;
  }
  a {
    color: #34d399;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  .current {
    color: #e5e7eb;
    font-weight: 600;
  }
  .sep {
    color: #4b5563;
  }
</style>
